import React from "react";
import URI from "urijs";
import Routes from "routing/Routes";
import SelectViewWithParameter from "./SelectViewWithParameter";
class ExecuteViewWithValue extends React.Component {
  constructor() {
    super(...arguments);
    this._onSubmit = (selectedView, selectedParameter) => {
      this.props.onClose();
      if (selectedView && selectedParameter) {
        const uri = new URI(Routes.VIEWS.VIEWID(selectedView)).search({
          [selectedParameter]: this.props.value
        });
        const newWindow = window.open(uri.toString(), "_blank");
        newWindow.focus();
      }
    };
  }
  render() {
    return /* @__PURE__ */ React.createElement(SelectViewWithParameter, { onClose: this.props.onClose, onSubmit: this._onSubmit });
  }
}
export default ExecuteViewWithValue;
